import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SubmitPIN from '../../../components/common/SubmitPIN';
import { hasOmniPIN } from '../../../modules/account/selectors';
import FormMessage from '../../FormMessage';
import withOmni from '../../withOmni';
import { request, viewEnter } from '../actions';
import TransferRestrictions from '../Restrictions';

export class Transfer extends Component {
  componentWillMount() {
    this.props.viewEnter();
  }

  render() {
    const { onSubmit, hasPIN } = this.props;

    return (
      <div className="withdraw">
        <div className="container--fixed">
          <FormMessage className="withdraw__message" />
          {hasPIN ? (
            <SubmitPIN onSubmit={onSubmit} />
          ) : (
            <TransferRestrictions />
          )}

        </div>
      </div>
    );
  }
}

Transfer.propTypes = {
  hasPIN: PropTypes.bool,
  viewEnter: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  hasPIN: hasOmniPIN(state)
});

const mapDispatchToProps = {
  viewEnter,
  onSubmit: request
};

export default withOmni(connect(mapStateToProps, mapDispatchToProps)(Transfer));
